import { render } from "./MusubiKpiCard.vue?vue&type=template&id=c21967b4&scoped=true"
import script from "./MusubiKpiCard.vue?vue&type=script&lang=js"
export * from "./MusubiKpiCard.vue?vue&type=script&lang=js"

import "./MusubiKpiCard.vue?vue&type=style&index=0&id=c21967b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21967b4"]])

export default __exports__